/** @jsxImportSource @emotion/react */
import useStyle from './eightyPercentDiscount.style';

const EightyPercentDiscountBanner = () => {
  const s = useStyle();
  return (
    <div css={s.bannerWrapper}>
      <span>
        Welcome back — <b>Enjoy 80% Off Security Equipment + 50% off cameras</b>
      </span>
    </div>
  );
};

export default EightyPercentDiscountBanner;
